import React from 'react';
import Navbar from '../components/Navbar';
import Hero from '../components/Hero';
import LogoMarquee from '../components/LogoMarquee';
import Services from '../components/Services';
import FlexibleFunding from '../components/FlexibleFunding';
import HowItWorks from '../components/HowItWorks';
import WhyChoose from '../components/WhyChoose';
import Testimonials from '../components/Testimonials';
import FAQ from '../components/FAQ';
import QuoteForm from '../components/QuoteForm';
import Footer from '../components/Footer';

export default function Home() {
  return (
    <>
      <Navbar />
      <Hero />
      <LogoMarquee />
      <Services />
      <FlexibleFunding />
      <HowItWorks />
      <WhyChoose />
      <Testimonials />
      <FAQ />
      <QuoteForm />
      <Footer />
    </>
  );
}
